import { createSlice } from '@reduxjs/toolkit';
import { EsicConfigurationState } from './configurationTypes';
import {createEsicConfiguration,fetchEsicConfigurationList,fetchEsicConfigurationById,updateEsicConfiguration,deleteEsicConfiguration} from './configurationActions';

const initialState: EsicConfigurationState = {
  configList: [],
  selectedConfig: undefined,
  loading: false,
  error: undefined,
};

const esicConfigurationSlice = createSlice({
  name: 'esicConfiguration',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create
      .addCase(createEsicConfiguration.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(createEsicConfiguration.fulfilled, (state, action) => {
        state.loading = false;
        state.configList.push(action.payload.data);
      })
      .addCase(createEsicConfiguration.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch All
      .addCase(fetchEsicConfigurationList.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchEsicConfigurationList.fulfilled, (state, action) => {
        state.loading = false;
        state.configList = action.payload.data;
      })
      .addCase(fetchEsicConfigurationList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Fetch By ID
      .addCase(fetchEsicConfigurationById.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(fetchEsicConfigurationById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedConfig = action.payload;
      })
      .addCase(fetchEsicConfigurationById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update
      .addCase(updateEsicConfiguration.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(updateEsicConfiguration.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.configList.findIndex((item) => item.config_id === action.meta.arg.id);
        if (index !== -1) {
          state.configList[index] = { ...state.configList[index], ...action.meta.arg };
        }
      })
      .addCase(updateEsicConfiguration.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Delete
      .addCase(deleteEsicConfiguration.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(deleteEsicConfiguration.fulfilled, (state, action) => {
        state.loading = false;
        state.configList = state.configList.filter(
          (item) => item.config_id !== action.meta.arg
        );
      })
      .addCase(deleteEsicConfiguration.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default esicConfigurationSlice.reducer;
